export default __webpack_public_path__ + "f533928ac9a34b74e8c800657829abfc.svg";